// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__lK_a0","title":"Heading_title__3xqin","number":"Heading_number__2fkhS"};